import React from "react";
import { ClockIcon } from "lucide-react";
import { useLoopingCountdown } from "../hooks/useLoopingCountdown";
type CountdownProps = {
  tone?: "light" | "dark";
};
export function Countdown({
  tone = "light"
}: CountdownProps) {
  const {
    hours,
    minutes,
    secs
  } = useLoopingCountdown();
  const units = [{
    value: hours,
    label: "Hours"
  }, {
    value: minutes,
    label: "Min"
  }, {
    value: secs,
    label: "Sec"
  }];
  const labelColor = tone === "dark" ? "text-white" : "text-navy";
  const sepColor = tone === "dark" ? "text-white/70" : "text-navy";
  const boxColor = tone === "dark" ? "bg-white text-ink" : "bg-ink text-white";
  const unitColor = tone === "dark" ? "text-white/70" : "text-ink/60";
  return <div className="flex flex-col items-center" role="timer" aria-live="off" data-id="element-20" data-mp="373kpz78h7aa1">
      <p className={`flex items-center gap-2 text-xs sm:text-sm font-bold uppercase tracking-wider ${labelColor}`} data-id="element-21" data-mp="10c3fvob1vu32">
        <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-22" data-mp="15ad8ps9ayili" />
        The special offer ends in:
      </p>
      <div className="mt-3 flex items-start gap-2 sm:gap-3" data-id="element-23" data-mp="xzvgr94povz2">
        {units.map((u, i) => <React.Fragment key={u.label} data-id="element-24" data-mp="t1agxatdgeb5" data-mpi={i}>
            <div className="flex flex-col items-center" data-id="element-25" data-mp="t093x0ssphqs">
              <span className={`flex h-[68px] w-[68px] sm:h-20 sm:w-20 items-center justify-center rounded-xl font-serif text-3xl sm:text-4xl font-bold tabular-nums shadow-lg ${boxColor}`} data-id="element-26" data-mp="17pohtg789sp2">
                {String(u.value).padStart(2, "0")}
              </span>
              <span className={`mt-1.5 text-[11px] font-semibold uppercase tracking-wider ${unitColor}`} data-id="element-27" data-mp="a4997i8fo03i">{u.label}</span>
            </div>
            {i < units.length - 1 && <span className={`pt-4 sm:pt-5 text-2xl font-bold ${sepColor}`} aria-hidden="true" data-id="element-28" data-mp="k0vsw3p0wl3y">
                :
              </span>}
          </React.Fragment>)}
      </div>
    </div>;
}